export class RenderInfo {
}
RenderInfo.loopStTm = 0;
RenderInfo.loopCount = 0;
